"use client";

import { Translate } from "@/components/Translate";
import FlagIcon from "@/components/icons/FlagIcon";
import { Input } from "@/components/ui/Input";
import { RadioButton, RadioGroup } from "@/components/ui/Radio/Radio";
import { countries, useGeo } from "@/i18n/routing";
import type { GeoLocale } from "@frend-digital/next/i18n";
import { matchSorter } from "match-sorter";
import {
	type FormEvent,
	Fragment,
	useDeferredValue,
	useMemo,
	useOptimistic,
	useRef,
	useState,
} from "react";
import styles from "./GeoSelector.module.css";

export const CountryForm = ({
	country,
	setCountry,
}: {
	country: string;
	setCountry: React.Dispatch<React.SetStateAction<string>>;
}) => {
	const [search, setSearch] = useState("");

	const changeCountry = (country: unknown) => {
		if (typeof country !== "string") return;

		setCountry(country);
	};

	const deferredSearch = useDeferredValue(search);

	const filteredCountries = useMemo(() => {
		return matchSorter(countries, deferredSearch, {
			keys: ["name", "country"],
		});
	}, [deferredSearch]);

	return (
		<div>
			<fieldset className={styles.buttons}>
				<div className={styles.intro}>
					<legend className={styles.title}>
						<Translate>Country</Translate>
					</legend>
					<Translate>Select delivery country</Translate>
				</div>
				<Input
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					className={styles.input}
					placeholder="Search..."
				/>
				<RadioGroup value={country} onValueChange={changeCountry}>
					{filteredCountries.map((country) => (
						<Fragment key={country.country}>
							{/* biome-ignore lint/a11y/useAnchorContent: <explanation> */}
							<a className="sr-only" href={`/${country.language}-${country.country}`} />
							<RadioButton
								key={country.country}
								label={<Translate>{country.name}</Translate>}
								value={country.country}
								icon={<FlagIcon countryCode={country.country} />}
							/>
						</Fragment>
					))}
				</RadioGroup>
			</fieldset>
		</div>
	);
};
